import React from "react";
import { Button, Flex, Link } from "@chakra-ui/react";
import { ReactComponent as DocStar } from "../images/icons/doc-star-alt.svg";
import { FiArrowRight } from "@react-icons/all-files/fi/FiArrowRight";

type PathToInsightProps = {
  title: string;
  to: string;
};

const PathToInsight = ({ title, to }: PathToInsightProps) => {
  return (
    <Button
      mb="32px"
      py="24px"
      fontSize="lg"
      variant="outline"
      as={Link}
      href={to}
      display="inline-flex"
      alignItems="center"
      justifyContent="space-between"
      onClick={() => {
        window.gtag?.("event", "internal_learn_link_click", {
          title,
        });
      }}
      _hover={{
        textDecoration: "none",
        bg: "gray.100",
      }}
    >
      <Flex mr="2" alignItems="center" as="span">
        <DocStar /> &nbsp;&nbsp;
        {title}
      </Flex>
      <FiArrowRight />
    </Button>
  );
};

export default PathToInsight;
